import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect, useSelector } from 'react-redux';
import { VaStatementOfTruth } from '@department-of-veterans-affairs/component-library/dist/react-bindings';
import { isLoggedIn } from 'platform/user/selectors';
import {
  fullNameReducer,
  statementOfTruthFullName,
  statementOfTruthBodyElement,
} from '~/platform/forms/components/review/PreSubmitSection';

import { setPreSubmit as setPreSubmitAction } from 'platform/forms-system/src/js/actions';

const PreSubmitInfo = ({
  formData,
  preSubmitInfo,
  showError,
  setPreSubmit,
  user,
}) => {
  const { statementOfTruth } = preSubmitInfo;
  const { claimantType } = formData;
  const loggedIn = useSelector(isLoggedIn);
  const [
    statementOfTruthSignatureBlurred,
    setStatementOfTruthSignatureBlurred,
  ] = useState(false);

  const useProfileFullName = loggedIn && claimantType === 'VETERAN';

  const expectedFullName = statementOfTruthFullName(
    formData,
    {
      ...statementOfTruth,
      useProfileFullName,
    },
    user?.profile?.userFullName,
  );

  return (
    <VaStatementOfTruth
      heading={statementOfTruth.heading || 'Statement of truth'}
      inputLabel={statementOfTruth.textInputLabel || 'Your full name'}
      inputValue={formData.statementOfTruthSignature}
      inputMessageAriaDescribedby={`${
        statementOfTruth.heading || 'Statement of truth'
      }: ${statementOfTruth.messageAriaDescribedby}`}
      inputError={
        (showError || statementOfTruthSignatureBlurred) &&
        fullNameReducer(formData.statementOfTruthSignature) !==
          fullNameReducer(expectedFullName)
          ? `Please enter your name exactly as it appears on your application: ${expectedFullName}`
          : undefined
      }
      checked={formData.statementOfTruthCertified}
      onVaInputChange={event =>
        setPreSubmit('statementOfTruthSignature', event.detail.value)
      }
      onVaInputBlur={() => setStatementOfTruthSignatureBlurred(true)}
      onVaCheckboxChange={event =>
        setPreSubmit('statementOfTruthCertified', event.detail.checked)
      }
      checkboxError={
        showError && !formData.statementOfTruthCertified
          ? 'You must certify by checking the box'
          : undefined
      }
    >
      {statementOfTruthBodyElement(formData, statementOfTruth.body)}
    </VaStatementOfTruth>
  );
};

PreSubmitInfo.propTypes = {
  formData: PropTypes.object.isRequired,
  setPreSubmit: PropTypes.func.isRequired,
  preSubmitInfo: PropTypes.shape({
    statementOfTruth: PropTypes.shape({
      heading: PropTypes.string,
      textInputLabel: PropTypes.string,
      messageAriaDescribedby: PropTypes.string,
      body: PropTypes.string,
    }),
  }),
  showError: PropTypes.bool,
  user: PropTypes.shape({
    login: PropTypes.shape({
      currentlyLoggedIn: PropTypes.bool,
    }),
    profile: PropTypes.shape({
      userFullName: PropTypes.object,
    }),
  }),
};

const mapDispatchToProps = {
  setPreSubmit: setPreSubmitAction,
};

export default connect(null, mapDispatchToProps)(PreSubmitInfo);
